/**
 * Application constants
 */

// Default auto-logout time in milliseconds (30 minutes)
export const DEFAULT_AUTO_LOGOUT_TIME = 30 * 60 * 1000;

// Activity check interval in milliseconds (1 minute)
export const ACTIVITY_CHECK_INTERVAL = 60 * 1000;

// Default pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Date formats
export const DATE_FORMAT = 'MMM dd, yyyy';
export const DATE_TIME_FORMAT = 'MMM dd, yyyy HH:mm';
export const TIME_FORMAT = 'HH:mm';

// Order edit window (in hours)
export const ORDER_EDIT_WINDOW_HOURS = 24;

// QR Code ID length
export const QR_CODE_ID_LENGTH = 12;

// File upload limits
export const MAX_CSV_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_CSV_TYPES = ['text/csv', 'application/vnd.ms-excel'];

// API endpoints
export const API_ENDPOINTS = {
  HEALTH: '/health',
  USERS: {
    CREATE: '/api/users/create',
    UPDATE: (userId: string) => `/api/users/${userId}`,
    DELETE: (userId: string) => `/api/users/${userId}`,
  },
  AUTH: {
    CUSTOM_TOKEN: '/api/auth/custom-token',
  },
  EMAIL: {
    TEST: '/api/email/test',
  },
} as const;

// Firestore collections
export const COLLECTIONS = {
  USERS: 'users',
  PRODUCTS: 'products',
  ORDERS: 'orders',
  COMPANIES: 'companies',
  COPIERS: 'copiers',
  QR_CODES: 'qrCodes',
  SUPPORT_REQUESTS: 'supportRequests',
  TRANSACTIONS: 'transactions',
  SETTINGS: 'settings',
} as const;

// Settings document IDs
export const SETTINGS_IDS = {
  APP_SETTINGS: 'appSettings',
  AUTO_LOGOUT: 'autoLogout',
} as const;

// Order statuses with display info
export const ORDER_STATUS_CONFIG = {
  pending: { label: 'Pending', color: 'warning' as const },
  confirmed: { label: 'Confirmed', color: 'info' as const },
  processing: { label: 'Processing', color: 'info' as const },
  shipped: { label: 'Shipped', color: 'primary' as const },
  delivered: { label: 'Delivered', color: 'success' as const },
  cancelled: { label: 'Cancelled', color: 'error' as const },
} as const;

// Navigation drawer width
export const DRAWER_WIDTH = 260;
export const DRAWER_WIDTH_COLLAPSED = 64;

// Local storage keys
export const STORAGE_KEYS = {
  REMEMBER_EMAIL: 'rememberEmail',
  THEME_MODE: 'themeMode',
} as const;
